export const GET_TICKET_CATEGORIES_SUCCESS = 'GET_TICKET_CATEGORIES_SUCCESS';
export const ADD_TICKET_CATEGORY_SUCCESS = 'ADD_TICKET_CATEGORY_SUCCESS';
export const DELETE_TICKET_CATEGORY_SUCCESS = 'DELETE_TICKET_CATEGORY_SUCCESS';
export const SET_FETCHING_TICKET_CATEGORIES = 'SET_FETCHING_TICKET_CATEGORIES'